<script lang="ts"></script>

<div class="doc">
  <div class="doc-inner">
    <h1 class="page">Page not found</h1>
    <p class="h-lead">That page doesn’t exist. <a href="#/">Back to the report</a>.</p>
  </div>
</div>
